"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.register = register;
exports.subscribeToEvents = subscribeToEvents;
exports.dispatch = dispatch;
exports.addListener = addListener;
exports.removeListener = removeListener;
const lodash_1 = require("lodash");
let sse;
function register(sseBaseUrl = "/api", topics) {
    if (sse) {
        throw new Error("SSE already registered!");
    }
    sse = new EventSource(sseBaseUrl + "/subscribe" + (topics ? "/" + topics.join(",") : ""));
}
function subscribeToEvents(events, wait = 0) {
    events.forEach((event) => {
        const fn = (e) => dispatch(event, JSON.parse(e.data));
        sse.addEventListener(event, wait ? (0, lodash_1.throttle)(fn, wait) : fn, false);
    });
}
/**
 * @example document.dispatchEvent(new CustomEvent('test', {detail: ['foo', 'bar']}));
 */
function dispatch(event, ...args) {
    document.dispatchEvent(new CustomEvent(event, { detail: args }));
}
/**
 * @example document.addEventListener('test', e => console.log(...e.detail));
 */
function addListener(event, handler) {
    document.addEventListener(event, handler, false);
}
function removeListener(event, handler) {
    document.removeEventListener(event, handler, false);
}
//# sourceMappingURL=sse.js.map